import script from "./PoolFees.vue?vue&type=script&lang=ts&setup=true"
export * from "./PoolFees.vue?vue&type=script&lang=ts&setup=true"

import "./PoolFees.vue?vue&type=style&index=0&id=0dcf610e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dcf610e"]])

export default __exports__